<template>
  <div
    v-if="interactive"
    class="pa-0"
    role="button"
    data-testid="heart-icon"
    tabindex="0"
    :aria-label="labelAria"
    @click="emits('click')"
    @keydown="onKeydown"
  >
    <SIcon v-bind="$attrs" class="icon-hover" :icon="icon" decorative />
  </div>
  <div
    v-else
    class="pa-0"
    data-testid="heart-icon"
    aria-hidden="true"
    @click="emits('click')"
  >
    <SIcon v-bind="$attrs" class="icon-hover" :icon="icon" decorative />
  </div>
</template>

<script lang="ts" setup>
import { mdiHeart, mdiHeartOutline } from '@mdi/js'
import SIcon from '~/components/SIcon.vue'
import { useKeyboardActivation } from '~/composables/useKeyboardActivation'

interface Props {
  /**
   * Accessible name of the heart. Only applied when `interactive` is true and
   * the heart is itself the focusable control. When `interactive` is false the
   * heart is decorative and the focusable wrapper around it (e.g. the SBtn in
   * WishlistMenu) must carry the name, otherwise it is announced twice.
   */
  labelAria: string
  filled?: boolean
  interactive?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  filled: false,
  interactive: true
})
const emits = defineEmits<{
  (e: 'click'): void
}>()

defineOptions({ inheritAttrs: false })

const icons = { mdiHeart, mdiHeartOutline }
const icon = computed(() => props.filled ? icons.mdiHeart : icons.mdiHeartOutline)
const onKeydown = useKeyboardActivation(() => emits('click'))
</script>

<style lang="scss" scoped>
</style>
